export const environment = {
    production: false,
    EPAGO_REACT_SDK_URL: 'https://qas.pay.button.epago.pe/web/react-sdk-1.0.0/epago-sdk.umd.js',
    VTEX_EPAGO_API_BASE_URL: 'https://qa.pagoweb.pe/vtex',
    INDXP_PROCESSOR_API_BASE_URL: 'https://indxp-processor-bhap7t33ia-ue.a.run.app',
    SIMULADOR_AGORA_API_BASE_URL: 'https://qa.pagoweb.pe',
    MAINTAINER_API_BASE_URL: 'https://qas.api.epago.pe',
    WEBHOOK_SITE_BASE_URL: '/api-webhook',
    IDENTIFIER: '49663545-17e3-4ecb-9edb-52654accc12b',
    IDENTIFIER_MIFARMA: '0d9fb2ee-ca46-41f1-8734-76a351ba5d74',
    SIGNEDELEMNT: 'AAAABBBB',
    SIGNEDELEMENT_MIFARMA: 'ORD00179PEN55.12',
    SIGNATURE: '8204e16ee56c7a6b1474b9ac27acd6df16a1172eafcef2d2cbb45624e52d032ba333d7065ef4473dbdf47830426382ab8152a91a4789c3e317c135d66c50ed7c',
    SIGNATURE_MIFARMA: '83217ff577b282d8142690ecd57df16e62567fa3568eea7a85c0524b7184847342619ed634ec691125824438f2d570ec94ff9cdbccc2aa29c73df4630c5a7aa4'
};
